import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="selectbox"
export default class extends Controller {
	connect() {
		// Elemente initieren damit man sie nicht unnötigerweise als Target definieren muss
		this.select = this.element.querySelector("select")
		this.label = this.element.querySelector("span")
		this.select.dataset.action = this.select.hasAttribute("data-action") ? `${this.select.dataset.action} selectbox#update` : "selectbox#update"

		// Selected Item der selectbox in das Label schreiben
		this.label.innerHTML = this.select.selectedOptions[0].text

		// Selectbox Width initial setzen; Ist vor allem für Elemente notwendig,
		// wenn die Selectbox beim initialisieren nicht sichtbar ist
		this.select.style.width = this.selectboxBreiteFeststellen() + "px"
	}

	update() {
		this.updateLabelText()
	}

	// Private Methods

	updateLabelText() {
		this.label.innerHTML = this.select.selectedOptions[0].text
		this.select.style.width = `${this.label.clientWidth}px`
	}

	selectboxBreiteFeststellen() {
		let maxBreite = 10000

		const tmpLabel = document.createElement("span")
		tmpLabel.innerHTML = this.select.selectedOptions[0].text

		// Schauen ob das Label Element eine Max Breien Angabe hat
		const wClass = Array.from(this.label.classList).find((className) => className.startsWith("max-w-"))

		if (wClass) {
			// Regulärer Ausdruck, um den Inhalt innerhalb der eckigen Klammern zu erfassen
			let match = wClass.match(/max-w-\[(.*?)\]/)
			if (match) {
				maxBreite = parseInt(match[1])
			}
		}

		// Rendern im DOM und Speichern der Breite
		tmpLabel.style = { top: "-1000px", left: "-1000px" }
		document.querySelector("body").appendChild(tmpLabel)
		const breite = tmpLabel.offsetWidth
		tmpLabel.remove()

		return Math.min(breite, maxBreite)
	}
}
